import { useId } from "react";

// Фірмова зірка замість емодзі: однаково виглядає на iPhone, Android і Windows
function StarIcon({ size = 20, className }) {
  const gradientId = "star" + useId().replace(/:/g, "");
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ flexShrink: 0, display: "inline-block", verticalAlign: "middle" }}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFD66B" />
          <stop offset="100%" stopColor="#F4A62A" />
        </linearGradient>
      </defs>
      <path
        d="M12 2.6l2.75 5.72 6.25.8-4.58 4.36 1.16 6.2L12 16.66l-5.58 3.02 1.16-6.2L3 9.12l6.25-.8L12 2.6z"
        fill={`url(#${gradientId})`}
        stroke="#E0931C"
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default StarIcon;
